// extracted by mini-css-extract-plugin
export default {"box":"err404_box__d6S+D","text":"err404_text__YiizB"};